import axios from "axios";
import appSettings from "../../../config/config";
const apiUrl = appSettings.apiUrl

const getAccounts = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/accounts`
    );
    return response;
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

export default {
  getAccounts
};
